import Config from 'config';

/**
 * @flow
 */

const initialState = [{
  id: 'mymessages',
  href: `${Config.api.host}/dashboard/conversations`,
  title: 'My Messages'
}, {
  id: 'manage',
  href: `${Config.api.host}/dashboard/my-events`,
  title: 'Manage / Edit My Events'
}, {
  id: 'paymentprefs',
  href: `${Config.api.host}/dashboard/payment-preferences`,
  title: 'Payment Preferences'
}, {
  id: 'organizations',
  href: `${Config.api.host}/dashboard/organizations`,
  title: 'Users and Permissions'
}];

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/ui/quick-links.js